<template>
    <Page behind-nav class="home">
        <section class="procreate-hero procreate-hero--fade-out procreate-hero--content-bottom">
            <div class="procreate-hero__media">
                <img class="rmnp-hidden" :src="$asset($t('home.hero.video_poster'))" />
                <video
                    class="rm-hidden"
                    :src="$asset($t('home.hero.video'))"
                    :poster="$asset($t('home.hero.video_poster'))"
                    playsinline
                    muted
                    autoplay
                    loop
                ></video>
                <CreditMedia
                    :credit-only="true"
                    artist="Stéphane Bourez"
                    artwork="Alien Panther"
                    :commission="true"
                    weighting="top"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/stephane-bourez-alien-panther.jpg')"
                />
                <CreditMedia
                    :credit-only="true"
                    artist="Al Jerek Torrijas"
                    artwork="Saved By The Bell"
                    :commission="true"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/al-jerek-torrijas-saved-by-the-bell.jpg')"
                />
                <CreditMedia
                    credit-only
                    artist="Sam Rodriguez / Andrew Proctor"
                    artwork="Skateboard"
                    :commission="true"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/sam-rodriquez-skateboard.jpg')"
                />
                <!-- <CreditMedia
                    :credit-only="true"
                    artist="Aaron Griffin"
                    artwork="Untitled Work"
                    :commission="true"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/aaron-griffin-untitled.jpg')"
                />
                <CreditMedia
                    :credit-only="true"
                    artist="Aaron Griffin"
                    artwork="Sketch Series"
                    :commission="true"
                    weighting="bottom"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/aaron-griffin-sketch-series.jpg')"
                /> -->
                <CreditMedia
                    :credit-only="true"
                    artist="Angela Sung"
                    artwork="Untitled"
                    :commission="false"
                    :thumbnail="$asset('images/credit-thumbnails/ipad/angela-sung-car.jpg')"
                />
            </div>

            <div class="procreate-hero__content"></div>
        </section>

        <section class="home-container container home-container--top">
            <div class="procreate-copy procreate-copy--center">
                <h1 class="sr-only">{{ $t("home.title") }}</h1>
                <p class="text-subheading home-hero__highlight">{{ $t("home.hero.subheading") }}</p>
                <h2 class="text-heading text-heading--md" v-html="$t('home.hero.heading')"></h2>
                <!-- <p class="text-body" v-html="$t('home.hero.body')"></p> -->
                <div class="home-hero__actions">
                    <ProButton :to="{ name: 'ipad-whats-new' }" :aria-label="$t('home.hero.button_label')" pill variant="alt"
                        >{{ $t("home.hero.button") }}<ProIcon icon="cta-right"
                    /></ProButton>
                    <ProButton
                        v-ga-event="['leads', 'Send to App Store (Ipad)', 'Homepage Hero']"
                        href="https://apps.apple.com/app/apple-store/id425073498?pt=345446&ct=Website_Homepage&mt=8"
                        target="_blank"
                        pill
                        variant="primary"
                        >{{ $t("global.buy") }}<ProIcon icon="cta-right"
                    /></ProButton>
                </div>
            </div>

            <div class="home-masonry home-masonry--top">
                <!-- iPad -->
                <div class="masonry-section masonry-section--full">
                    <ProLink :to="{ name: 'ipad' }" :aria-label="$t('home.ipad.label')" class="masonry-tile masonry-tile--procreate masonry-tile--full-layout">
                        <div class="masonry-tile__container">
                            <div class="masonry-tile__content" aria-hidden="true">
                                <h2 class="text-subheading">{{ $t("home.ipad.subheading") }}</h2>
                                <p class="text-heading" v-html="$t('home.ipad.heading')"></p>
                            </div>
                        </div>
                        <div
                            class="masonry-tile__bg mobile"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.ipad.image_mobile'))}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center!important',
                            }"
                        ></div>
                        <div
                            class="masonry-tile__bg tablet"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.ipad.image_mobile'))}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center!important',
                            }"
                        ></div>
                        <div
                            class="masonry-tile__bg desktop"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.ipad.image'))}')`,
                                backgroundSize: 'auto 100%',
                                backgroundPosition: 'left center',
                            }"
                        >
                            <CreditMedia
                                :credit-only="true"
                                artist="Sam Rodriguez"
                                artwork="Nectar"
                                :commission="false"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/sam-rodriguez-nectar.jpg')"
                            />
                            <CreditMedia
                                :credit-only="true"
                                artist="Andrey Malykh"
                                artwork="Untitled"
                                :commission="false"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/andrey-malykh-untitled.jpg')"
                            />
                            <CreditMedia
                                :credit-only="true"
                                artist="Nikolai Lockertsen"
                                artwork="Field of Dreams"
                                :commission="true"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/nikolai-lockertsen-office-field-of-dreams.jpg')"
                            />
                            <CreditMedia
                                :credit-only="true"
                                artist="Christiane King"
                                artwork="Untitled Study"
                                :commission="true"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/christiane-king-working-portrait.jpg')"
                            />
                        </div>
                    </ProLink>
                </div>

                <!-- Pocket -->
                <div class="masonry-section masonry-section--third">
                    <ProLink
                        :to="{ name: 'pocket' }"
                        :aria-label="$t('home.pocket.label')"
                        class="masonry-tile masonry-tile--pocket masonry-tile--text-center"
                        :style="{ backgroundColor: '#0f0f0f' }"
                    >
                        <div class="masonry-tile__container">
                            <div class="masonry-tile__content" aria-hidden="true">
                                <h2 class="text-subheading">{{ $t("home.pocket.subheading") }}</h2>
                                <p class="text-heading" v-html="$t('home.pocket.heading')"></p>
                            </div>
                        </div>

                        <div
                            class="masonry-tile__bg mobile"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.pocket.image_mobile'))}')`,
                                backgroundPosition: 'center top 16px',
                                backgroundSize: 'cover',
                            }"
                        >
                            <CreditMedia
                                :credit-only="true"
                                artist="Angela Sung"
                                artwork="On Tokyo streets"
                                :commission="true"
                                weighting="bottom"
                                :thumbnail="$asset('images/credit-thumbnails/pocket/angela-sung-on-tokyo-streets.jpg')"
                            />
                            <CreditMedia
                                :credit-only="true"
                                artist="Sara Lee"
                                artwork="Chromatic Jungle"
                                :commission="true"
                                :thumbnail="$asset('images/credit-thumbnails/pocket/sara-lee-chromatic-jungle.jpg')"
                            />
                        </div>

                        <div
                            class="masonry-tile__bg tablet"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.pocket.image_tablet'))}')`,
                                backgroundPosition: 'center right',
                                backgroundSize: 'cover',
                            }"
                        ></div>
                        <div
                            class="masonry-tile__bg desktop"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.pocket.image'))}')`,
                                backgroundPosition: 'center top 16px',
                                backgroundSize: 'cover',
                            }"
                        ></div>
                    </ProLink>
                </div>

                <!-- Brushes -->
                <div class="masonry-section masonry-section--two-third">
                    <ProLink :to="{ name: 'ipad-brushes', hash: '#make-brushes' }" :aria-label="$t('home.brushes.label')" class="masonry-tile">
                        <div class="masonry-tile__container">
                            <div class="masonry-tile__content" aria-hidden="true">
                                <h2 class="text-subheading">{{ $t("home.brushes.subheading") }}</h2>
                                <p class="text-heading" v-html="$t('home.brushes.heading')"></p>
                            </div>
                        </div>
                        <div
                            class="masonry-tile__bg desktop"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.brushes.image'))}')`,
                                backgroundPosition: 'left bottom',
                                backgroundSize: '101% auto',
                            }"
                        ></div>
                        <div
                            class="masonry-tile__bg tablet"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.brushes.image_tablet'))}')`,
                                backgroundPosition: 'left bottom',
                                backgroundSize: 'auto 100%',
                            }"
                        ></div>
                        <div
                            class="masonry-tile__bg mobile"
                            :style="{
                                backgroundImage: `url('${$asset($t('home.brushes.image_mobile'))}')`,
                                backgroundPosition: 'left bottom',
                                backgroundSize: 'cover',
                            }"
                        ></div>
                        <CreditMedia
                            :credit-only="true"
                            artist="Christiane King"
                            artwork="Untitled Study"
                            :commission="true"
                            :thumbnail="$asset('images/credit-thumbnails/ipad/christiane-king-untitled.jpg')"
                        />
                    </ProLink>
                </div>
            </div>
        </section>

        <section class="home-container container">
            <div class="home-insight">
                <div class="home-insight__title-link">
                    <ProButton :to="{ name: 'insight' }" :aria-label="$t('home.insight.label')">
                        {{ $t("home.insight.subheading") }}<ProIcon icon="cta-right" />
                    </ProButton>
                    <h2 class="text-heading text-heading--sm" v-html="$t('home.insight.heading')"></h2>
                </div>
                <div class="home-insight__articles" v-if="latestArticles">
                    <InsightQuicklink v-for="relatedArticle in latestArticles" :key="relatedArticle.id" :article="relatedArticle" />
                </div>
            </div>
        </section>

        <section>
            <div class="home-container container">
                <div class="home-masonry home-masonry--bottom">
                    <!-- Timelapse -->
                    <div class="masonry-section masonry-section--two-third">
                        <ProLink
                            :to="{ name: 'ipad-video', hash: '#timelapse' }"
                            :aria-label="$t('home.timelapse.label')"
                            class="masonry-tile masonry-tile--gradient-top"
                            :style="{ backgroundColor: '#302117' }"
                        >
                            <div class="masonry-tile__container">
                                <div class="masonry-tile__content" aria-hidden="true">
                                    <h2 class="text-subheading">{{ $t("home.timelapse.subheading") }}</h2>
                                    <p class="text-heading" v-html="$t('home.timelapse.heading')"></p>
                                </div>
                            </div>

                            <div class="masonry-tile__bg">
                                <CreditMedia
                                    :video="true"
                                    :src="$asset($t('ipad.animation.video'))"
                                    :poster="$asset($t('ipad.animation.video_poster'))"
                                    artist="Asuka111"
                                    artwork="The Cat Caravan"
                                    :commission="true"
                                    :thumbnail="$asset('images/credit-thumbnails/ipad/asuka111-the-cat-caravan.jpg')"
                                />
                            </div>
                        </ProLink>
                    </div>

                    <!-- Folio -->
                    <div class="masonry-section masonry-section--third">
                        <ProLink
                            v-ga-event:click="['leads', 'Send to Folio']"
                            href="https://folio.procreate.art"
                            target="_blank"
                            class="masonry-tile masonry-tile--gradient-short"
                            :style="{ backgroundColor: '#0524BF' }"
                        >
                            <div class="masonry-tile__container">
                                <div class="masonry-tile__content" aria-hidden="true">
                                    <h2 class="text-subheading">{{ $t("home.folio.subheading") }}</h2>
                                    <p class="text-heading" v-html="$t('home.folio.heading')"></p>
                                </div>
                            </div>
                            <div
                                class="masonry-tile__bg mobile"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.folio.image_mobile'))}')`,
                                    backgroundSize: 'cover',
                                }"
                            ></div>

                            <div
                                class="masonry-tile__bg tablet"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.folio.image_tablet'))}')`,
                                    backgroundSize: 'cover',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg desktop"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.folio.image'))}')`,
                                    backgroundSize: 'cover',
                                }"
                            >
                                <CreditMedia
                                    :credit-only="true"
                                    artist="Sang Wook Kim"
                                    artwork="They Danced All Night"
                                    weighting="top"
                                    :thumbnail="$asset('images/credit-thumbnails/ipad/sang-wook-kim-the-danced-all-night.jpg')"
                                />
                            </div>
                        </ProLink>
                    </div>

                    <div class="masonry-section masonry-section--third masonry-section--sub-grid">
                        <!-- A11y -->
                        <ProLink
                            :to="{ name: 'ipad-accessibility' }"
                            :aria-label="$t('home.a11y.label')"
                            class="masonry-tile"
                            :style="{ backgroundColor: '#FED1C7' }"
                        >
                            <div class="masonry-tile__container">
                                <div class="masonry-tile__content light-mode" aria-hidden="true">
                                    <h2 class="text-subheading">{{ $t("home.a11y.subheading") }}</h2>
                                    <p class="text-heading" v-html="$t('home.a11y.heading')"></p>
                                </div>
                            </div>
                            <div
                                class="masonry-tile__bg desktop"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.a11y.image'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'left center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg tablet"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.a11y.image'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'left center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg mobile"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.a11y.image_mobile'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'bottom center',
                                }"
                            ></div>
                            <CreditMedia
                                :credit-only="true"
                                artist="Jhonny Núñez"
                                artwork="Desert"
                                :commission="true"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/jhonny-nunez-desert.jpg')"
                            />
                        </ProLink>

                        <!-- Facepaint -->
                        <ProLink
                            :to="{ name: 'ipad-superpowers', hash: '#facepaint' }"
                            :aria-label="$t('home.facepaint.label')"
                            class="masonry-tile"
                            :style="{ backgroundColor: '#f5f3f3' }"
                        >
                            <div class="masonry-tile__container">
                                <div class="masonry-tile__content light-mode" aria-hidden="true">
                                    <h2 class="text-subheading">{{ $t("home.facepaint.subheading") }}</h2>
                                    <p class="text-heading" v-html="$t('home.facepaint.heading')"></p>
                                </div>
                            </div>
                            <div
                                class="masonry-tile__bg desktop"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.facepaint.image'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'left center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg tablet"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.facepaint.image'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'left center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg mobile"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.facepaint.image_mobile'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                }"
                            ></div>
                            <CreditMedia
                                :credit-only="true"
                                artist="Nuwarhol"
                                artwork="Skull"
                                :commission="true"
                                :thumbnail="$asset('images/credit-thumbnails/ipad/nuwarhol-untitled.jpg')"
                            />
                        </ProLink>
                    </div>

                    <!-- EDU -->
                    <div class="masonry-section masonry-section--two-third masonry-section--full">
                        <ProLink
                            v-ga-event="['leads', 'Send to Education', 'Homepage Footer']"
                            href="//education.procreate.art"
                            target="_blank"
                            :aria-label="$t('home.education.label')"
                            class="masonry-tile"
                            :style="{ backgroundColor: '#033461' }"
                        >
                            <div class="masonry-tile__container">
                                <div class="masonry-tile__content" aria-hidden="true">
                                    <h2 class="text-subheading">{{ $t("home.education.subheading") }}</h2>
                                    <p class="text-heading" v-html="$t('home.education.heading')"></p>
                                    <!-- <p class="text-body" v-html="$t('home.education.body')"></p> -->
                                </div>
                            </div>
                            <div
                                class="masonry-tile__bg desktop"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.education.image'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg tablet"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.education.image_tablet'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                }"
                            ></div>
                            <div
                                class="masonry-tile__bg mobile"
                                :style="{
                                    backgroundImage: `url('${$asset($t('home.education.image_mobile'))}')`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center center',
                                }"
                            ></div>
                        </ProLink>
                    </div>
                </div>
            </div>
        </section>

        <ArtistCredits />
    </Page>
</template>

<script>
import { mapGetters } from "vuex";
import { parseISO, format } from "date-fns";

import LinkTile from "@/components/LinkTile";
import InsightLinkTile from "@/components/insight/InsightLinkTile";
import SingleIpad from "@/components/ipad/SingleIpad";
import CreditMedia from "@/components/CreditMedia";
import ArtistCredits from "@/components/ArtistCredits";
import InsightQuicklink from "@/components/insight/InsightQuicklink";

export default {
    components: {
        InsightLinkTile,
        LinkTile,
        SingleIpad,
        CreditMedia,
        ArtistCredits,
        InsightQuicklink,
    },

    data: () => ({
        world: null,
    }),

    computed: {
        ...mapGetters({
            articles: "insight/getArticles",
            credits: "creditMedia/getMedia",
        }),
        latestArticles() {
            if (this.articles) {
                return this.articles.slice(0, 2);
            } else {
                return null;
            }
        },
    },

    methods: {
        formatMonthDayYear(date) {
            return format(parseISO(date), "MMM d',' yyyy");
        },

        formatYear(date) {
            return parseISO(date).getFullYear();
        },
    },

    async mounted() {
        this.$store.dispatch("insight/fetchArticles");
    },

    beforeDestroy() {
        this.world?.destroy();
        this.world = null;
    },

    head() {
        return {
            script: [
                {
                    type: "application/ld+json",
                    json: {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Procreate",
                        url: "https://procreate.art/",
                        logo: "https://assets.procreate.art/img/procreate-icon-search-display.png",
                        sameAs: [
                            "https://www.facebook.com/procreate",
                            "https://twitter.com/Procreate",
                            "https://www.instagram.com/Procreate/",
                            "https://www.youtube.com/channel/UCU88WY0qX2bzDjjOLOj-Gng",
                            "https://wikipedia.org/wiki/Procreate_(software)",
                        ],
                    },
                },
            ],
            bodyAttrs: {
                class: "ultra-dark-mode",
            },
        };
    },
};
</script>
